export default {
    searchList: {
        searchTxt: [
            {
                name: '年份',
                placeholder: '年份',
                value: 'certYear',
                type: 'time',
                timeType: 'year',
                format: 'yyyy',
                valueFormat: 'yyyy',
                unfold: true,
                span: 3,
                multiple: false
            },
            {
                name: '会计期间',
                placeholder: '会计期间',
                value: 'accountCycle',
                type: 'time',
                timeType: 'month',
                format: 'yyyy-MM',
                valueFormat: 'yyyy-MM',
                unfold: true,
                span: 3,
                multiple: false
            },
            {
                name: '单据状态',
                value: 'taskStatus',
                type: 'select',
                optionNum: 'BMS_NO_OWING_TAX_TASK_STATUS',
                unfold: true,
                span: 3,
                multiple: false
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        switchType: true,
        tableCut: false,
        clickState: true,
        selectBtn: false,
        height: 'calc(100vh - 204px)',
        columns: [
            { label: '单据号', prop: 'certTaskNo', width: '180px' },
            { label: '年份', prop: 'certYear', width: '60px' },
            { label: '会计期间', prop: 'accountCycle', width: '80px' },
            { label: '供应商编码', prop: 'supCode', width: '100px' },
            { label: '供应商名称', prop: 'supName', width: '270px' },
            { label: '主体性质', prop: 'property', width: '100px', type: 'select', optionNum: 'SYS_SUPPLIERS_PROPERTY' },
            { label: '备注', prop: 'remark', width: '200px' },
            { label: '发布时间', prop: 'publishTime', width: '150px' },
            { label: '截止日期', prop: 'deadlineTime', width: '150px' },
            { label: '分公司', prop: 'companyName', width: '80px' },
            { label: '经营中心', prop: 'centerName', width: '140px' },
            { label: '安得对接人', prop: 'followUserName', width: '120px' },
            { label: 'MIP状态', prop: 'mipStatus', width: '100px', type: 'select', optionNum: 'SYS_BMS_MIP_STATUS' },
            { label: '单据状态', prop: 'taskStatus', width: '100px', type: 'select', optionNum: 'BMS_NO_OWING_TAX_TASK_STATUS' },
            { label: '附件', prop: 'attachment', type: 'linkText', width: '200px' }
        ],
        leftOperation: true,
        customBtn: false,
        action: [
            {
                label: '上传附件',
                event: 'upload',
                type: 'text',
                ifHas: '07090001'
            },
            {
                label: '提交',
                event: 'submit',
                type: 'text',
                ifHas: '07090002'
            }
        ],
        leftWidth: 150
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10
    }
};
